import { useState, useEffect } from 'react';
import classes from './index.module.scss';
import { useAppSelector } from '../../hooks/useAppSelector';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CustomSnackbarProps } from '../CustomSnackbar';
import { setToastState } from '../../store/toast/toastSlice';

const AdaptiveHeader = () => {
  const dispatch = useDispatch();
  const assessmentState = useAppSelector((state) => state.assessment);
  const toastState = useAppSelector((state) => state.toast);
  const timeRemain = assessmentState.time_remaining;

  const openSnackbar = (
    type: CustomSnackbarProps['type'],
    message: CustomSnackbarProps['message']
  ) => {
    dispatch(
      setToastState({
        ...toastState,
        type,
        open: true,
        message,
      })
    );
  };

  const GetTimeSnackbarMessage = (time: number) => {
    if (time === 300) return '5 minutes left';
    if (time === 900) return '15 minutes left';
    if (time === 1800) return '30 minutes left';
    return 'NA';
  };

  useEffect(() => {
    if (timeRemain === 300) {
      openSnackbar('warning', GetTimeSnackbarMessage(300));
    } else if (timeRemain === 900) {
      openSnackbar('warning', GetTimeSnackbarMessage(900));
    } else if (timeRemain === 1800) {
      openSnackbar('warning', GetTimeSnackbarMessage(1800));
    }
  }, [timeRemain]);

  return (
    <header className={classes.container}>
      <div>
        <div className={classes.assessmentTitle}>
          {assessmentState.assessment_name}
        </div>
      </div>
    </header>
  );
};

export default AdaptiveHeader;
